import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import { useCallback, useEffect, useId } from 'react';
import { useStateStore } from '../../stores/useStateStore';

export const useUpdateChatContext = (data: object) => {
  const id = useId();

  const modify = useStateStore((state) => state.modifyChatContext);
  const remove = useStateStore((state) => state.removeChatContextModifer);

  useEffect(() => {
    modify({ id, data });

    return () => remove(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
};

export const useUpdateScreenChatContext = (data?: object) => {
  const { key: id, name, params } = useRoute();
  const { canGoBack } = useNavigation();

  const modify = useStateStore((state) => state.modifyChatContext);
  const remove = useStateStore((state) => state.removeChatContextModifer);

  useFocusEffect(
    useCallback(() => {
      modify({
        id,
        data: { screen: { name, params, canGoBack: canGoBack(), ...data } },
      });

      return () => remove(id);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, name, params, data])
  );
};
